import { call, put } from 'redux-saga/effects'
import { NdlArtifactsActions } from '../reducers/NdlArtifactsRedux'

export const findNdlArtifacts = function* (api, { payload }) {
  try {
    const query = (payload && payload.query) || payload || {}

    const response = yield call(api.create, 'ndl/artifacts/filter', query)

    yield put(NdlArtifactsActions.findSuccess(response))
  } catch (err) {
    yield put(NdlArtifactsActions.findFailure(err.message))
  }
}
